"use strict";

var _ = require('underscore');

exports.accessibleHash = {
  // Для инвалидов-колясочников
  a1: 'Пологие съезды при сходе с тротуара',
  a2: 'Парковка для инвалидов – не далее 50 м от входа',
  a3: 'Возможность подъезда к крыльцу на автомобиле',
  a4: 'Кнопка вызова помощника на входной двери',
  a5: 'Двери шириной более 0,9 м',
  a6: 'Пороги отсутствуют (не более 1,4 см)',
  a7: 'Пандусы шириной не менее 1 м',
  a8: 'Грузовой лифт',
  a9: 'Сотрудники, которые могут поднять на этаж',
  a10: 'Отдельный оборудованный туалет для инвалидов',
  a11: 'Кнопка (в туалете) для вызова помощника',
  a12: 'Сменное кресло-коляска в вестибюле',
  a13: 'Подъезд к оборудованию/экспонатам – шире 0,9 м',
  a14: 'Часть экспозиций – на высоте 0,7–1,2 м',
  a15: 'Выделенные места в зрительном зале (для театра и кинотеатра) с возможностью доступа на инвалидном кресле (не менее 3 % и не менее 2 шт.)',
  a16: 'Возможность посещения группой инвалидов на колясках',
  // Для инвалидов по зрению (слепых)
  b1: 'Тактильный указатель при входе на территорию',
  b2: 'Тактильные полосы на асфальте перед препятствиями',
  b3: 'Кнопка вызова помощника на входной двери',
  b4: 'Тифлосурдопереводчик (для слепоглухонемых)',
  b5: 'Отдельные экспозиции (контактные зоны)',
  b6: 'Тактильные подписи к экспонатам',
  b7: 'Тактильные подписи на навигации',
  b8: 'Тактильные подписи на перилах лестниц (указание этажа)',
  b9: 'Система тифлоперевода (для кинотеатров)',
  b10: 'Лифты со звуковой навигацией',
  b11: 'Системы аудиоинформирования',
  b12: 'Сотрудник-помощник для помощи в передвижении внутри ОК',
  b13: 'Возможность посещения группами инвалидов по зрению',
  b14: 'Доступ с собакой-поводырем',
  // Для инвалидов по слуху (глухие и глухонемые)
  c1: 'Визуальная информация об учреждении культуры',
  c2: 'Визуальная навигация внутри учреждения культуры',
  c3: 'Информационные стенды, бегущая строка',
  c4: 'Сурдопереводчик',
  c5: 'Системы для пользователей слуховых аппаратов и кохлеарных имплантов или текстофоны для глухих',
  c6: 'Сенсорные терминалы с возможностью вызова сотрудника',
  c7: 'Субтитры (для кинофильмов)',
  c8: 'Возможность посещения группой глухих (глухонемых)',
  c9: 'Специальные/отдельные мероприятия для инвалидов по слуху',
  // Для инвалидов с ментальными нарушениями
  d1: 'Специалисты, работающие с инвалидами с ментальными нарушениями',
  d2: 'Отдельные экспозиции' // В рамках «Пушкинской карты»
  // e1: 'Комплексный билет на инвалида и сопровождающего при оплате Пушкинской картой'

};
exports.accessibleCategoriesHash = {
  a: 'Для инвалидов-колясочников',
  b: 'Для инвалидов по зрению (слепых)',
  c: 'Для инвалидов по слуху (глухие и глухонемые)',
  d: 'Для инвалидов с ментальными нарушениями' // e: 'В рамках «Пушкинской карты»'

};
exports.accessibleFilters = _.map(exports.accessibleCategoriesHash, function (title, categoryKey) {
  return {
    title: title,
    value: categoryKey,
    children: _.chain(exports.accessibleHash).pick(function (value, key) {
      return key.startsWith(categoryKey);
    }).map(function (value, key) {
      return {
        title: value,
        value: key
      };
    }).value()
  };
});